import { defineComponent } from "vue";
import { useNuxtApp } from "#imports";
export default defineComponent({
  name: "NuxtPageDependency",
  // Fixes "[Vue warn]: Extraneous non-props attributes (data-v-inspector)
  // were passed to component but could not be automatically inherited because
  // component renders fragment or text root nodes."
  inheritAttrs: false,
  setup(_props, ctx) {
    if (!ctx.slots.default) {
      return;
    }
    const renderSlot = function() {
      return ctx.slots.default();
    };
    if (import.meta.server) {
      const nuxtApp = useNuxtApp();
      if (nuxtApp.payload.error || nuxtApp._nuxtPageDependenciesRendered) {
        return renderSlot;
      }
      return new Promise(function(resolve) {
        const resolver = function() {
          resolve(renderSlot);
        };
        if (nuxtApp.payload.error || nuxtApp._nuxtPageDependenciesRendered) {
          return resolver();
        }
        nuxtApp.hooks.hookOnce("nuxt-page-dependencies:rendered", resolver);
        nuxtApp.hooks.hookOnce("app:error", resolver);
        nuxtApp.hooks.hookOnce("vue:error", resolver);
      });
    }
    return renderSlot;
  }
});
